import { useMutation } from "@tanstack/react-query";
import ApiClient from "../../../api/ApiClient";
import { UserAssignment } from "../interfaces/UserAssignment";
import { AxiosError } from "axios";

async function post(data: { userId: string, deviceIds: number[] }): Promise<UserAssignment[]> {
    try {
        const response = await ApiClient({ url: "/user-assignments", method: "POST", data });
        if (response.status === 200) {
            return response.data;
        }
        throw new Error("Unexpected response status: " + response.status);
    } catch (error) {
        throw new Error(error instanceof AxiosError ? error.response?.data?.error : "An unexpected error occurred");
    }
}

export function usePostUserAssignmentMutation(onSuccess: (data: UserAssignment[]) => void, onError: (error: Error) => void) {
    return useMutation<UserAssignment[], Error, {userId: string, deviceIds: number[] }>({
        mutationKey: ["post-user-assignment"],
        mutationFn: post,
        onSuccess: onSuccess,
        onError: onError
    });
}  